import {ModuleWithProviders, NgModule} from '@angular/core'
import {TfSelectComponent} from './types/tf-select/tf-select.component'
import {TfBooleanComponent} from './types/tf-boolean/tf-boolean.component'
import {TfRangeComponent} from './types/tf-range/tf-range.component'
import {TfIntervalComponent} from './types/tf-interval/tf-interval.component'
import {TfStringComponent} from './types/tf-string/tf-string.component'
import {TfHtmlComponent} from './types/tf-html/tf-html.component'
import {TfSizeComponent} from './types/tf-size/tf-size.component'
import {TfLinkComponent} from './types/tf-link/tf-link.component'
import {TfSmartlistComponent} from './types/tf-smartlist/tf-smartlist.component'
import {AdminSharedModule} from '../../../../compob2b-admin/src/app/admin-shared/admin-shared.module'
import {
  NbAccordionModule,
  NbButtonModule,
  NbFormFieldModule,
  NbIconModule,
  NbInputModule,
  NbSpinnerModule,
  NbTooltipModule
} from '@nebular/theme'
import {RouterLink} from '@angular/router'
import {FormsModule, ReactiveFormsModule} from '@angular/forms'
import {AsyncPipe, DatePipe, NgClass, NgForOf, NgIf, SlicePipe} from '@angular/common'
import {NgMultiLabelTemplateDirective, NgSelectComponent} from '@ng-select/ng-select'
import {TemplateFeaturesComponent} from './template-features/template-features.component'
import {
  DamItemTemplateFeaturesService
} from '../../../../compob2b-admin/src/app/cabinet/dam/files/create-update/dam-item-template-features.service'
import {
  TemplateFeatureService
} from '../../../../compob2b-admin/src/app/cabinet/pim/product/create-update/features/template-feature.service'
import {CatalogService} from '../../../../compob2b-admin/src/app/cabinet/pim/catalog/catalog.service'
import {DamCatalogService} from '../../../../compob2b-admin/src/app/cabinet/dam/services/dam-catalog.service'
import {
  ThreeStateCheckboxComponent
} from '../../../../compob2b-admin/src/app/admin-shared/custom-form-types/three-state-checkbox/three-state-checkbox.component'

@NgModule({
    exports: [
        TfSelectComponent,
        TfBooleanComponent,
        TfRangeComponent,
        TfIntervalComponent,
        TfStringComponent,
        TfHtmlComponent,
        TfSizeComponent,
        TfLinkComponent,
        TfSmartlistComponent,
        TemplateFeaturesComponent,
    ],
    imports: [
        NbIconModule,
        NbTooltipModule,
        RouterLink,
        ReactiveFormsModule,
        NgIf,
        NbInputModule,
        NgClass,
        NgSelectComponent,
        AsyncPipe,
        NgMultiLabelTemplateDirective,
        NgForOf,
        SlicePipe,
        NbButtonModule,
        NbAccordionModule,
        NbSpinnerModule,
        DatePipe,
        NbFormFieldModule,
        FormsModule,
        AdminSharedModule,
        ThreeStateCheckboxComponent,
        TfSelectComponent,
        TfBooleanComponent,
        TfRangeComponent,
        TfIntervalComponent,
        TfStringComponent,
        TfHtmlComponent,
        TfSizeComponent,
        TfLinkComponent,
        TfSmartlistComponent,
        TemplateFeaturesComponent
    ]
})
export class FeaturesModule {

  public static forDam(): ModuleWithProviders<FeaturesModule> {
    return {
      ngModule: FeaturesModule,
      providers: [
        {provide: TemplateFeatureService, useClass: DamItemTemplateFeaturesService},
        {provide: 'templateFeatureService', useClass: DamItemTemplateFeaturesService},
        {provide: CatalogService, useClass: DamCatalogService},
        {provide: 'catalogService', useClass: DamCatalogService},
      ]
    };
  }

  public static forPim(): ModuleWithProviders<FeaturesModule> {
    return {
      ngModule: FeaturesModule,
      providers: [
        {provide: TemplateFeatureService, useClass: TemplateFeatureService},
        {provide: 'templateFeatureService', useClass: TemplateFeatureService},
      ]
    };
  }

}
